module.exports = __webpack_public_path__ + "img/button_close_search.9a4e2b9c.png";